import request from '@/utils/request';

// 用户信息
export async function getAccountInfo(params: any) {
  return request.get('/my/info', {
    params: params,
  });
}

// 红包明细
export async function getRedpacketDetail(params: any) {
  return request.get('my/redpacket', {
    params: params,
  });
}

// 红包兑换
export async function exchangeRedpacket(params: any) {
  return request.get('my/redpacket_exchange', {
    params: params,
  });
}

// 订单明细
export async function getOrderDetail(params: any) {
  return request.get('my/order', {
    params: params,
  });
}

// 红包、礼包、分享等奖励领取
// todo 接口名称有误
export async function receiveAward(params: any) {
  return request.get('Reward/go', {
    params: params,
  });
}